if (document.documentElement.lang.toLowerCase().split('-')[0] === 'de') {
(() => {
  'use strict';
const tx=value=>(document.documentElement.lang.toLowerCase().split('-')[0]==='de'?globalThis.AsteriaGermanCopy:globalThis.AsteriaItalianCopy)?.text(value)??String(value??'');
  if (globalThis.__asteriaResultShareBound) return;
  globalThis.__asteriaResultShareBound = true;

  function payload(root) {
    const text = root.dataset.shareText || '';
    const url = root.dataset.shareUrl || globalThis.location.href;
    return { text, url };
  }

  function openShare(url) {
    globalThis.open(url, '_blank', 'noopener,noreferrer,width=720,height=640');
  }

  async function copyText(root, value, successMessage) {
    const status = root.querySelector('[data-ae-share-status]');
    try {
      if (navigator.clipboard && typeof navigator.clipboard.writeText === 'function') {
        await navigator.clipboard.writeText(value);
      } else {
        const area = document.createElement('textarea');
        area.value = value;
        area.setAttribute('readonly', '');
        area.style.position = 'fixed';
        area.style.opacity = '0';
        document.body.append(area);
        area.select();
        const ok = document.execCommand('copy');
        area.remove();
        if (!ok) throw new Error('copy failed');
      }
      if (status) status.textContent = tx(successMessage || root.dataset.copySuccess || 'Copied.');
    } catch (_) {
      if (status) status.textContent = tx(root.dataset.copyFailed || tx('Copy unavailable.'));
    }
  }

  document.addEventListener('click', async (event) => {
    const button = event.target.closest('[data-ae-share-platform]');
    if (!button) return;
    const root = button.closest('[data-ae-result-share]');
    if (!root || root.hidden) return;

    const { text, url } = payload(root);
    const combined = (text + '\n' + url).trim();
    const platform = button.dataset.aeSharePlatform;

    if (platform === 'copy') {
      await copyText(root, url, root.dataset.linkCopySuccess);
      return;
    }
    if (platform === 'native') {
      if (navigator.share) {
        try { await navigator.share({ title: 'Asteria Elite', text, url }); } catch (_) {}
      } else { await copyText(root, combined); }
      return;
    }
    if (platform === 'whatsapp') {
      openShare('https://wa.me/?text=' + encodeURIComponent(combined));
      return;
    }
    if (platform === 'facebook') {
      openShare('https://www.facebook.com/sharer/sharer.php?u=' + encodeURIComponent(url));
      return;
    }
    if (platform === 'x') {
      openShare('https://twitter.com/intent/tweet?text=' + encodeURIComponent(text) + '&url=' + encodeURIComponent(url));
      return;
    }
    if (platform === 'instagram') {
      if (navigator.share) {
        try {
          await navigator.share({ title: 'Asteria Elite', text, url });
          return;
        } catch (_) {
          return;
        }
      }
      await copyText(root, combined);
    }
  });
})();

} else {
(() => {
  'use strict';
  if (globalThis.__asteriaResultShareBound) return;
  globalThis.__asteriaResultShareBound = true;

  function payload(root) {
    const text = root.dataset.shareText || '';
    const url = root.dataset.shareUrl || globalThis.location.href;
    return { text, url };
  }

  function openShare(url) {
    globalThis.open(url, '_blank', 'noopener,noreferrer,width=720,height=640');
  }

  async function copyText(root, value, successMessage) {
    const status = root.querySelector('[data-ae-share-status]');
    try {
      if (navigator.clipboard && typeof navigator.clipboard.writeText === 'function') {
        await navigator.clipboard.writeText(value);
      } else {
        const area = document.createElement('textarea');
        area.value = value;
        area.setAttribute('readonly', '');
        area.style.position = 'fixed';
        area.style.opacity = '0';
        document.body.append(area);
        area.select();
        const ok = document.execCommand('copy');
        area.remove();
        if (!ok) throw new Error('copy failed');
      }
      if (status) status.textContent = successMessage || root.dataset.copySuccess || 'Copied.';
    } catch (_) {
      if (status) status.textContent = root.dataset.copyFailed || 'Copy unavailable.';
    }
  }

  document.addEventListener('click', async (event) => {
    const button = event.target.closest('[data-ae-share-platform]');
    if (!button) return;
    const root = button.closest('[data-ae-result-share]');
    if (!root || root.hidden) return;

    const { text, url } = payload(root);
    const combined = (text + '\n' + url).trim();
    const platform = button.dataset.aeSharePlatform;

    if (platform === 'copy') {
      await copyText(root, url, root.dataset.linkCopySuccess);
      return;
    }
    if (platform === 'native') {
      if (navigator.share) {
        try { await navigator.share({ title: 'Asteria Elite', text, url }); } catch (_) {}
      } else { await copyText(root, combined); }
      return;
    }
    if (platform === 'whatsapp') {
      openShare('https://wa.me/?text=' + encodeURIComponent(combined));
      return;
    }
    if (platform === 'facebook') {
      openShare('https://www.facebook.com/sharer/sharer.php?u=' + encodeURIComponent(url));
      return;
    }
    if (platform === 'x') {
      openShare('https://twitter.com/intent/tweet?text=' + encodeURIComponent(text) + '&url=' + encodeURIComponent(url));
      return;
    }
    if (platform === 'instagram') {
      if (navigator.share) {
        try {
          await navigator.share({ title: 'Asteria Elite', text, url });
          return;
        } catch (_) {
          return;
        }
      }
      await copyText(root, combined);
    }
  });
})();

}
